import type { CatalogItem } from '~/models/common'

export const gameEngines: CatalogItem[] = [
  {
    label: 'Adobe AIR',
    value: 1,
  },
  {
    label: 'Buildbox',
    value: 2,
  },
  {
    label: 'Cocos2d (or other version of framework)',
    value: 3,
  },
  {
    label: 'Construct',
    value: 4,
  },
  {
    label: 'Corona',
    value: 5,
  },
  {
    label: 'CryEngine',
    value: 6,
  },
  {
    label: 'Custom',
    value: 7,
  },
  {
    label: 'Defold',
    value: 8,
  },
  {
    label: 'Flash',
    value: 23,
  },
  {
    label: 'Frostbite',
    value: 9,
  },
  {
    label: 'Gamebryo',
    value: 10,
  },
  {
    label: 'GameMaker Studio',
    value: 11,
  },
  {
    label: 'Godot',
    value: 12,
  },
  {
    label: 'HTML5',
    value: 25,
  },
  {
    label: 'id Tech',
    value: 13,
  },
  {
    label: 'Lumberyard',
    value: 14,
  },
  {
    label: 'Marmalade',
    value: 15,
  },
  {
    label: 'Other',
    value: 24,
  },
  {
    label: 'RenPy',
    value: 28,
  },
  {
    label: 'RPG Maker',
    value: 16,
  },
  {
    label: 'Source',
    value: 17,
  },
  {
    label: 'SpriteKit',
    value: 18,
  },
  {
    label: 'Unigine',
    value: 19,
  },
  {
    label: 'Unity',
    value: 20,
  },
  {
    label: 'Unreal Engine 3 & older',
    value: 21,
  },
  {
    label: 'Unreal Engine 4',
    value: 22,
  },
  {
    label: 'Unreal Engine 5',
    value: 26,
  },
  {
    label: 'XNA',
    value: 27,
  },
]
